import { buildJobylonEmbedUrl } from "@/app/(site)/_components/SanityBlocks/JobylonBlock/buildJobylonEmbedUrl"
import { type JobylonEmbedConfig } from "@/app/(site)/_components/SanityBlocks/JobylonBlock/types"

type CleanupFn = () => void

function getWidgetStyles(container: HTMLElement) {
    const probe = document.createElement("span")
    container.appendChild(probe)

    const styles = {
        color: getComputedStyle(probe).color,
        fontFamily: getComputedStyle(probe).fontFamily,
        fontSize: getComputedStyle(probe).fontSize
    }

    probe.remove()
    return styles
}

function bindIframeMessaging(
    iframe: HTMLIFrameElement,
    container: HTMLElement
): CleanupFn {
    const onMessage = (event: MessageEvent) => {
        const payload = event.data as { name?: string; data?: unknown }

        if (!payload?.name || !event.source || event.source !== iframe.contentWindow) {
            return
        }

        if (payload.name === "jbl:ready") {
            iframe.contentWindow?.postMessage(
                { name: "jbl:referrer", data: window.location.href },
                "*"
            )
            iframe.contentWindow?.postMessage(
                { name: "jbl:styles", data: getWidgetStyles(container) },
                "*"
            )
            return
        }

        if (payload.name === "jbl:setHeight" && typeof payload.data === "number") {
            iframe.style.cssText = `width: 100% !important; height: ${payload.data}px !important; border: none !important; overflow: hidden !important;`
        }
    }

    const onResize = () => {
        iframe.contentWindow?.postMessage({ name: "jbl:resize", data: "" }, "*")
    }

    window.addEventListener("message", onMessage)
    window.addEventListener("resize", onResize)

    return () => {
        window.removeEventListener("message", onMessage)
        window.removeEventListener("resize", onResize)
    }
}

export function mountJobylonWidget(
    container: HTMLElement,
    config: JobylonEmbedConfig,
    targetId: string,
    iframeTitle: string
): CleanupFn {
    container.innerHTML = ""

    const iframe = document.createElement("iframe")
    iframe.id = `jobylon-jobs-widget-iframe:${targetId}`
    iframe.src = buildJobylonEmbedUrl(config, targetId)
    iframe.title = iframeTitle
    iframe.width = "100%"
    iframe.setAttribute(
        "style",
        "width: 100% !important; height: 0 !important; border: none !important; overflow: hidden !important;"
    )
    iframe.setAttribute("allowtransparency", "true")
    iframe.setAttribute("frameborder", "0")
    iframe.scrolling = "no"
    iframe.tabIndex = 0

    container.appendChild(iframe)

    return bindIframeMessaging(iframe, container)
}

export function clearJobylonWidget(container: HTMLElement) {
    container.innerHTML = ""
}
